import { AutogenLayoutARCycleCodes } from "./autogen/AutogenLayoutARCycleCodes";
import { DuplicateId } from "@mcleod/dispatch";

export class ARCycleCodes extends AutogenLayoutARCycleCodes {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "ar_cycle_code",
            screenName: "Miscellaneous Invoicing Cycle Code",
            navigateToUrl: "lme/ar/ARCycleCodes?mode=update&key="
        });
    }
}
